import React from "react";
import "./procced.css";
import { useNavigate } from "react-router-dom";
import proArrow from "../assets/proArrow.png"


const Procced = ({ bottom,cartCount, totalAmount, preCart, page }) => {
 //console.log("preCart",preCart)
  const navigate = useNavigate();
//console.log("preCart",  preCart[0]&&preCart.reduce((total, item) => total + item.count, 0))
  const goMyCart = () => {
    const machineId=localStorage.getItem("machineId")
   
    localStorage.setItem("mycart", true);

 /*    mpCartClicked({
      EventName: mixpanelEvent,
      data: { ItemsInCart: cartItemsList, TotalCartValue: totalAmount },
    }); */
    navigate(`/myCart?machineId=${machineId}`,);
     
  };

  return (
    <div className="proccedModal" style={{ bottom:page=="vmlist"?bottom:"10px" }}>
      <div className="proccedBox">
        <div className="proccedContent">
          <div className="cartInfo">
            <h3>
              {preCart[0]&&preCart.reduce((total, item) => total + item.count, 0)} Item{preCart[0]&&preCart.reduce((total, item) => total + item.count, 0) > 1 ? "s" : ""}{" "}
              <span className="cartValue">(₹ {totalAmount.toFixed(2)})</span>
            </h3>
          </div>

          <div className="divider"></div>

          <button className="proceedBtn" onClick={goMyCart}>
            <span>Proceed To Pay</span>
            <img src={proArrow} alt="arrow" className="arrowIcon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Procced;
